import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/category/movie", label: "电影分类" },
  { to: "/category/tv", label: "电视剧分类" },
  { to: "/search", label: "影视搜索" },
  { to: "/about", label: "关于我们" },
];

const friendLinks = ["光影资源站", "剧集速递", "电影情报局", "追剧日历"];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300 mt-auto">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500">
                <i className="ri-film-fill text-lg text-background-50"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950 font-heading">黄色影院</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              一站式高清电影电视剧资源聚合平台，涵盖多类型影视作品，让浏览、筛选与查询都变得轻松简单。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <Link to="/" className="cursor-pointer">快速导航</Link>
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">友情链接</h4>
            <div className="flex flex-wrap gap-2">
              {friendLinks.map((name) => (
                <span
                  key={name}
                  className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200"
                >
                  {name}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-400"></i>
                </span>
                service@yellowcinema.demo
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-primary-400"></i>
                </span>
                在线客服 09:00 - 22:00
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-primary-400"></i>
                </span>
                线上平台 · 无线下门店
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 黄色影院 · 本站为影视资源聚合演示平台，所有内容仅供展示学习
          </p>
          <p className="text-xs text-foreground-500">
            站内资源均为演示数据，不提供真实播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}